import { FromAccountPermissionDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../../shared';

export class FromAccountPermission extends DomainEntity<FromAccountPermissionDto> {
    public createDefault(): this {
        throw new Error('not implemented');
    }

    public get id() {
        return this.dto.id;
    }

    public get accountType() {
        return this.dto.fromAccountType;
    }

    public set accountType(type: string) {
        this.dto.fromAccountType = type;
    }

    public get isAllowed() {
        return this.dto.isAllowed;
    }

    public set isAllowed(value: boolean) {
        this.dto.isAllowed = value;
    }
}
